import { render, staticRenderFns } from "./InformationLine.vue?vue&type=template&id=aff377dc&scoped=true&"
import script from "./InformationLine.vue?vue&type=script&lang=ts&"
export * from "./InformationLine.vue?vue&type=script&lang=ts&"
import style0 from "./InformationLine.vue?vue&type=style&index=0&id=aff377dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aff377dc",
  null
  
)

export default component.exports